<template>
  <!-- 新增页 -->
  <div>
    <van-nav-bar
      title="新增"
      right-text="保存"
      @click-right="save"
      :fixed='true'
    />
    <div class="main">
        <van-form>
         <van-field
            readonly
            clickable
            label-class='formTitle'
            name="picker"
            :value="form.sysType"
            label="业务类型"
            placeholder="点击选择业务类型"
            @click="showPickerOne = true"
          />
          <van-popup v-model="showPickerOne" position="bottom">
            <van-picker
              show-toolbar
              :columns="listSysType"
              @confirm="onConfirmOne"
              @cancel="showPickerOne = false"
            />
          </van-popup>

           <van-field
            readonly
            clickable
            label-class='formTitle'
            name="picker"
            :value="form.dataType"
            label="资金性质"
            placeholder="点击选择资金性质"
            @click="showPickerTwo = true"
          />
          <van-popup v-model="showPickerTwo" position="bottom">
            <van-picker
              show-toolbar
              :columns="listDataType"
              @confirm="onConfirmTwo"
              @cancel="showPickerTwo = false"
            />
          </van-popup>

          <van-field
            v-model="form.dept"
            label-class='formTitle'
            name="缴款单位"
            label="缴款单位"
            placeholder="请输入缴款单位"
          />
          <van-field
            v-model="form.idCard"
            label-class='formTitle'
            name="证件号码"
            label="证件号码"
            placeholder="请输入证件号码"
          />
          <van-field
            v-model="form.phone"
            label-class='formTitle'
            name="联系电话"
            label="联系电话"
            type='number'
            placeholder="请输入联系电话"
          />
          <van-field
            v-model="form.remark"
            label-class='formTitle'
            name="备注"
            label="备注"
            placeholder="请输入备注"
          />
        </van-form>
        <div class="total">
            <span>收费项目</span>
            <span>总金额：{{Number(total).toFixed(2)}}元</span>
        </div>

        <div class="list">
            <div class="item" v-for="(item,index) in listData" :key='index'>
                <div class="title">
                    <span>[{{item.itemCode}}]{{item.itemName}}</span>
                    <van-icon name="delete"  @click="delItem(index)"/>
                </div>
                <div class="content">
                  <p>数量：{{Number(item.biNumber).toFixed(2)}}</p>
                  <p>标准：{{Number(item.standard).toFixed(2)}}</p>
                  <p>金额：{{Number(item.actualAmt).toFixed(2)}}元</p>
                </div>
            </div>
        </div>

        <van-button round type="info"   size="large" @click="showItem">添加收费项目</van-button>
        <div class="dialog">
          <van-dialog v-model="show" title="添加收费项目" show-cancel-button @confirm='saveItem' :before-close='beforeClose'>
              <van-form >
                <van-field
                    readonly
                    clickable
                    label-class='formTitle'
                    name="picker"
                    :value="addForm.item"
                    label="收费项目"
                    placeholder="点击选择收费项目"
                    @click="showPickerThree = true"
                  />
                  <van-field
                    v-model="addForm.biNumber"
                    label-class='formTitle'
                    name="数量"
                    label="数量"
                    @blur="fixed2(addForm,'bin')"
                    type='number'
                    placeholder="请输入数量"
                  />
                  <van-field
                    v-model="addForm.standard"
                    label-class='formTitle'
                    name="标准"
                    label="标准"
                    type='number'
                    @blur="fixed2(addForm,'sta')"
                    :disabled='disabled'
                    placeholder="请输入标准"
                  />
                  <van-field
                    v-model="addForm.actualAmt"
                    label-class='formTitle'
                    name="金额"
                    label="金额"
                    placeholder="请输入金额"
                    disabled
                  />
              </van-form>
          </van-dialog>
        </div>

         <van-popup v-model="showPickerThree" position="bottom">
            <van-picker
              show-toolbar
              :columns="chargingItemTree"
              @confirm="onConfirmInner"
              @cancel="showPickerThree = false"
            />
          </van-popup>

    </div>
  </div>
</template>

<script>
// 重写 tofixed方法
Number.prototype.toFixed = function (d) {
     var s = this + "";
     if (!d) d = 0;
     if (s.indexOf(".") == -1) s += ".";
     s += new Array(d + 1).join("0");
     if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
         var s = "0" + RegExp.$2, pm = RegExp.$1, a = RegExp.$3.length, b = true;
         if (a == d + 2) {
             a = s.match(/\d/g);
             if (parseInt(a[a.length - 1]) > 4) {
                 for (var i = a.length - 2; i >= 0; i--) {
                     a[i] = parseInt(a[i]) + 1;
                     if (a[i] == 10) {
                         a[i] = 0;
                         b = i != 1;
                     } else break;
                 }
             }
             s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

         } if (b) s = s.substr(1);
         return (pm + s).replace(/\.$/, "");
     }
     return this + "";
 };
 import { Notify,Dialog } from 'vant';
export default {
  data() {
      return {
        form:{
          sysType:'',
          dataType:'',
          dept:'',
          idCard:'',
          phone:'',
          remark:'',
          sysTypeValue:'',
        },
        addForm:{
            item:'',
            biNumber:'',
            standard:'',
            actualAmt:'',
            isEdit:'',
            itemName:'',
            itemCode:'',
            itemId:''
        },
        showPickerOne: false,
        showPickerTwo: false,
        showPickerThree:false,
        show:false,
        listSysType:[],//业务类型
        listDataType:[],//资金性质
        sysTypeValue:'',
        dataTypeValue:'',
        chargingItemTree:[],//弹窗内选择器
        listData:[],//列表
        disabled:false,//标准是否可选
        total:0,
        vde:''
    };
  },
  watch: {
    addForm: {
      // 深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        if (val.biNumber > 0 && val.standard > 0) {
          val.actualAmt = Number(val.biNumber*val.standard).toFixed(2);
        }
      },
      deep: true
    }
  },
 async created() {
    if (this.$route.query.vde === undefined) {
      this.vde = ''
    }else {
      this.vde = this.$route.query.vde
    }
   await this.initSysType()
   await this.initDataType()
   await this.getDefault()
  },
  methods: {
    fixed2(val,i){
        if(i=='sta'){
          val.standard=Number(val.standard).toFixed(2);
        }else if(i=='bin'){
          val.biNumber=Number(val.biNumber).toFixed(2);
        } 
    },
    onConfirmOne(value) {
      if (value) {
        this.form.sysType = value.text;
        this.sysTypeValue = value.value;
      }
      this.showPickerOne = false;
    },
    onConfirmTwo(value) {
      if (value) {
        this.form.dataType = value.text;
        this.dataTypeValue = value.value
      }
      this.showPickerTwo = false;
    },
    onConfirmInner(value) {
      if (value) {
        console.log(value);
        this.addForm.item = value.text
        this.addForm.biNumber = value.biNumber
        this.addForm.actualAmt = value.actualAmt
        this.addForm.isEdit = value.isEdit
        this.addForm.itemName = value.itemName
        this.addForm.itemCode = value.itemCode
        this.addForm.itemId = value.itemId
        if (value.standard) {
          this.addForm.standard = Number(value.standard).toFixed(2)
        }else{
          this.addForm.standard="";
        }
        if (value.biNumber) {
          this.addForm.biNumber = Number(value.biNumber).toFixed(2)
        }
        if (value.actualAmt) {
          this.addForm.actualAmt = Number(value.actualAmt).toFixed(2)
        }
        if (value.isEdit==1) {
          this.disabled = false
        }else {
          this.disabled = true
        }
      }
      this.showPickerThree = false
    },
    beforeClose(action, done) {
      if (action == 'confirm') {
        done(false)
      }else {
        done()
      }
    },
    save() {
       let testPhone =/^1\d{10}$/
      if (this.form.sysType=='') {
        Notify({ type: 'danger', message: '请选择业务类型' });
      }else if(this.form.dataType=='') {
        Notify({ type: 'danger', message: '请选择资金性质' });
      }else if(this.form.dept=='') {
        Notify({ type: 'danger', message: '请输入缴款单位' });
      }else if(this.form.idCard=='') {
        Notify({ type: 'danger', message: '请输入证件号码' });
      }else if(this.form.phone=='') {
        Notify({ type: 'danger', message: '请输入联系电话' });
      }else if(!testPhone.test(this.form.phone)) {
         Notify({ type: 'danger', message: '手机号格式不正确' });
      }else if(this.listData.length==0){
        Notify({ type: 'danger', message: '请选择收费项目' });
      }else if(this.total==0){
         Notify({ type: 'danger', message: '收费总金额不能为0' });
      }else {
        let data = {
            dataType:this.dataTypeValue,
            sysType:this.sysTypeValue,
            idCard:this.form.idCard,
            phone:this.form.phone,
            paymentUnit:this.form.dept,
            paymentTotal:this.total,
            noticeNo:'',
            items:this.listData,
            remark:this.form.remark
        }
        this.request({
          url:'/business/addBusiness',
          method:'post',
          data:data
        }).then((res)=>{
            if (res.data.code==1000) {
              Notify({ type: 'success', message: '保存成功' });
              this.$router.push({path:'/payList?idCard='+this.form.idCard+'&paymentUnit='+this.form.dept+'&phone='+this.form.phone+'&type=0&vde='+this.vde})
              this.form.sysType = ''
              this.form.dataType = ''
              this.form.dept = ''
              this.form.idCard = ''
              this.form.phone = ''
              this.form.remark = ''
              this.sysTypeValue = ''
              this.dataTypeValue = ''
              this.listData= []
            }else {
              Dialog.alert({
                title: '错误提示',
                message: res.data.message,
              }).then(() => {
              });
            }
        })
      }
    },
    // 业务类型数据
    initSysType() {
      return new Promise(resolve => {
        this.request({
          url:'/system/dictionary/listDictData/sys_business_type',
          method:'get'
        }).then((res)=>{
          if (res.data.result != null) {
            const list = [];
            res.data.result.forEach(r => {
              if (r.value !== "1") {
                r.text=r.label
                list.push(r);
              }
            });
            this.listSysType = list;
          }
          resolve()

        })

      });
    },
    // 资金性质
    initDataType() {
      return new Promise(resolve => {
        this.request({
          url:'/system/dictionary/listDictData/sys_capital_property',
          method:'get',
        }).then((res)=>{
          if (res.data.result != null) {
             this.listDataType = res.data.result;
             this.listDataType.forEach((item)=> {
               item.text = item.label
             })
          }
          resolve()

        })
      });
    },
      // 默认数据
    getDefault() {
      let data={
        type:3
      }
       return new Promise(resolve => {
         this.request({
           url:'/busEduConfig/getBusEduConfig',
           method:'get',
           params:data
         }).then((res)=>{
           if (res.data.code == 1000) {
             let list = res.data.result
             list.forEach((item)=> {
               if (item.fieldName == "sysType") {
                 this.listSysType.forEach((val)=> {
                   if(item.fieldValue == val.value) {
                       this.form.sysType = val.label
                       this.sysTypeValue = val.value
                     }
                 })
               }
               if (item.fieldName == 'dataType') {
                 this.listDataType.forEach((val)=> {
                   if(item.fieldValue == val.value) {
                       this.form.dataType = val.label
                       this.dataTypeValue = val.value
                     }
                 })
               }
             })
           }
           resolve()

         })
        })
    },
      // 保存收费项目选择
    saveItem() {
      if(this.addForm.item=='') {
        Notify({ type: 'danger', message: '请填写收费项目' });
      }else if (this.addForm.biNumber=='' || this.addForm.biNumber==0) {
        Notify({ type: 'danger', message: '请填写收费数量' });
      }else if (this.addForm.standard=='' || this.addForm.standard==0) {
        Notify({ type: 'danger', message: '请填写收费标准' });
      }else {
        let obj = JSON.parse(JSON.stringify(this.addForm))
        let bool = this.listData.some((val) => {
          return val.itemId == obj.itemId
        })
        if (bool) {
           Notify({ type: 'danger', message: '不能选择同一收费项目' });
        }else {
          this.total=0
          this.listData.push(obj)
          this.listData.forEach((item)=>{
            this.total += Number(item.actualAmt)
          })
          this.show = false
        }
      }
    },
    // 删除收费项
    delItem(index) {
      Dialog.confirm({
        title: '提示',
        message: '确定删除'+this.listData[index].item+'?',
      })
      .then(() => {
        this.listData.splice(index,1)
        this.total=0
        this.listData.forEach((item)=>{
          this.total+=item.actualAmt
        })
      })
      .catch(() => {
      });
      
    },
    showItem() {
      if (this.form.dataType === "") {
        Dialog.alert({
          title: '错误提示',
          message: '请先选择资金性质',
        }).then(() => {
        });
        return;
      } else {
        this.show = true
        this.addForm.item = ''
        this.addForm.biNumber = ''
        this.addForm.standard = ''
        this.addForm.actualAmt = ''
        this.addForm.isEdit = ''
        this.addForm.itemName = ''
        this.addForm.itemCode = ''
        this.addForm.itemId = ''
        this.listItemByDeptId();
      }
    },
    listItemByDeptId() {
        const data = { deptId: "", itemType: this.dataTypeValue };
        this.request({
          url:'/deptItemConfig/listItemByDeptId',
          method:'get',
          params:data
        }).then((res)=>{
          if (res.data.code === 1000) {
            if (res.data.result) {
              this.chargingItemTree = res.data.result;
            }
            const itemArr = [];
            this.chargingItemTree.forEach(item => {
              const list = {};
              list.itemCode = item.attributes.itemCode;
              list.itemName = item.label;
              list.standard = item.attributes.standard;
              list.isEdit = item.attributes.isEdit;
              list.itemId = item.value;
              list.biNumber = 1;
              list.actualAmt = list.biNumber * list.standard;
              list.text = `[${list.itemCode}]${item.label}`
              itemArr.push(list);
            });
            this.chargingItemTree = itemArr
          }

        })
    },
  },
}
</script>

<style lang='scss'>
  .van-nav-bar  {
    .van-nav-bar__text {
      font-size: 16px;
    }
  }
  .main {
    margin-top: 60px;
    margin-bottom: 70px;
     padding: 0 2vw;
  }
  .total {
    margin-top: 15px;
    height:43px;
    background:rgba(255,255,255,1);
    box-shadow:4px 4px 4px 0px rgba(51,51,51,0.05);
    border-radius:5px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
    align-items: center;
    font-size: 15px;
    margin-bottom: 15px;
    >span:nth-of-type(2) {
      color: rgb(238, 10, 36);
    }
  }
  .van-form {
    background:rgba(255,255,255,1);
    box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
    border-radius:5px;
  }
  .van-cell {
    background: transparent;
  }
  .list {
    >.item {
      box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
      border-radius:5px;
      margin-bottom: 15px;
      background: #fff;
      .title {
        padding: 0 10px; 
        height: 40px;
        box-sizing: border-box;
        border-bottom: 1px solid #f7f7f7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
      
        >span{
          display: inline-block;
          white-space: nowrap;
          width: 80vw;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .content {
        font-size: 15px;
        padding: 10px;
        box-sizing: border-box;
        line-height: 24px;
      }
    }
  }
  .formTitle {
      padding-right: 20px;
      text-align-last: justify;
      color: #323233;
  } 
.sure {
  width: 50%;
  height: 50px;
  background: pink;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>